import { css } from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'
import { ResponsiveSize } from './types'

type Value = string | number

type PropertyProps = {
    type: string
    value: Value | [Value, Value]
    unit?: string
}

export const getSizeWithUnit = (size: number | string) =>
    typeof size === 'number' ? `${size}px` : size

export const getResponsiveStyles = (style: ResponsiveSize, type: string) => {
    if (!Array.isArray(style)) {
        return css`
            ${`${type}: ${getSizeWithUnit(style)};`}
        `
    }
    return css`
        ${`${type}: ${getSizeWithUnit(style[0])};`}
        @media ${respondAbove.xl} {
            ${`${type}: ${getSizeWithUnit(style[1])};`}
        }
    `
}

export const resolveResponsiveProp = ({ type, value, unit }: PropertyProps) => {
    const isArray = Array.isArray(value)

    return css`
        ${`${type}: ${isArray ? value[0] : value}${unit || ''}`};

        @media ${respondAbove.xl} {
            ${`${type}: ${isArray ? value[1] : value}${unit || ''}`};
        }
    `
}

export const scrollbar = () => css`
    ::-webkit-scrollbar {
        width: 6px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.colors.grayscale_400};
        border-radius: 8px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.colors.grayscale_500};
        border-radius: 8px;
    }
    ::-webkit-scrollbar-track {
        background: 0 0;
    }
`

export const applyThickLeftBorder = (isDarkMode?: boolean) => css`
    &::before,
    &::after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        width: 16px;
        height: 100%;
        background-color: ${({ theme }) => theme.colors.primary_500};
    }

    &::after {
        left: 8px;
        width: 8px;
        background-color: ${({ theme }) =>
            isDarkMode ? theme.colors.darkmode_500 : theme.colors.grayscale_0};
        border-bottom-left-radius: 8px;
        border-top-left-radius: 8px;
    }
`
